import React, { useState, useEffect } from 'react';
import { useFormContext } from 'contexts/FormContext';
import { steps } from 'utils/steps';

/**
 * Renders the form's header with a title, caption, and logo.
 *
 * @returns {React.Component} The Header component.
 */
const Header = () => {
  const { currentStep } = useFormContext();
  const [caption, setCaption] = useState('');

  useEffect(() => {
    if (steps[currentStep] && steps[currentStep].name) {
      setCaption(`Stap ${currentStep + 1} - ${steps[currentStep].name}`);
    } else {
      setCaption('Error - er is iets misgegaan');
    }
  }, [currentStep]);

  return (
    <div className='header'>
      <div>
        <h3 className='title'>Klus aanbieden</h3>
        <p className='caption'>{caption}</p>
      </div>
      <img className='logo' src='klusminuten.svg' alt='Klusminuten logo' />
    </div>
  );
};

export default Header;
